import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import ProtectedRouteV2 from './ProtectedRouteV2';
import PurchaseReturnEventsPage from '../pages/Purchase/fiscal/PurchaseReturnEventsPage';
import FiscalEventsPage from '../pages/Purchase/fiscal/FiscalEventsPage';

const purchaseFiscalEventRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route path="/purchases/returns" element={<><PageTitle title="Eventos de Retorno de Compras | POS System" /><PurchaseReturnEventsPage /></>} />
    <Route path="/purchases/returns/:purchaseId" element={<><PageTitle title="Eventos de Retorno de Compras | POS System" /><PurchaseReturnEventsPage /></>} />
    <Route path="/purchases/fiscal-events" element={<><PageTitle title="Historial de Eventos | POS System" /><FiscalEventsPage /></>} />
  </Route>
);

export default purchaseFiscalEventRoutes;
